import { FC, useContext, useRef, useState } from "react";
import { Box, Chip, CircularProgress, TextField, Typography, useTheme } from "@mui/material";
import { PatientManagementContext } from "./PatientManagementPlanProvider";
import KeyboardReturnIcon from '@mui/icons-material/KeyboardReturn';
type PropsType = {
  placeholder?: string;
  title?: string;
  chips: string[];
  setChips: (param: string[]) => void;
  loading?:boolean;
  component:"managementPlan" | "treatmentPlan" | "clinicalImpression" | null
};
const CustomChipInput: FC<PropsType> = ({
  chips,
  setChips,
  title,
  placeholder,
  loading,
  component
}) => {
  const theme = useTheme();
  const {setEditedField} = useContext(PatientManagementContext)
  const [inputValue, setInputValue] = useState<string>("");
  const textBoxRef = useRef<HTMLInputElement>();

  const handleAddChip = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter" && inputValue.trim()) {
      setChips([...chips, inputValue.trim()]);
      setInputValue("");
    }    
    if (event.key == "Backspace" && chips.length > 0 && inputValue == "") {
      const update = [...chips];
      update.pop();
      setChips(update);
    }
    setEditedField(component)
  };

  const handleDeleteChip = (index: number) => {
    const update = [...chips];
    update.splice(index, 1);
    setChips(update);
    setEditedField(component)
  };

  const handleFocusToText = () => {
    if (textBoxRef.current) {
      textBoxRef.current.focus();
    }
  };

  return (
    <div role="button" onClick={handleFocusToText} className="cursor-text">
      <Box
        className="border rounded py-2 px-2 flex flex-row flex-wrap gap-2 items-center"
        sx={{
          borderColor: theme.palette.grey[400],
          "&:hover": {
            borderWidth: 1,
            borderColor: theme.palette.primary.main,
          },
          "&:focus": {
            borderColor: theme.palette.error.main,
          },
        }}
      >
        {loading && <CircularProgress size={20} />}
        {chips?.map((chip, index) => (
          <Chip
            // size="small"
            key={index}
            label={chip}
            onDelete={() => handleDeleteChip(index)}
            sx={{
              marginRight: 0,
              height: "auto",
              "& .MuiChip-label": {
                display: "block",
                whiteSpace: "normal",
              },
            }}
          />
        ))}
        <div className="col-span-3">
          <TextField
            title={title || ""}
            placeholder={placeholder || ""}
            inputRef={textBoxRef}
            id="addText"
            fullWidth
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            onKeyDown={handleAddChip}
            sx={{
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  border: "none",
                },
                "&:hover fieldset": {
                  border: "none",
                },
                "&.Mui-focused fieldset": {
                  border: "none",
                },
              },
            }}
          />
        </div>
       {inputValue != "" && <Typography fontSize={12} color={"primary.main"}>Please press Enter <KeyboardReturnIcon/> key to add</Typography>}
      </Box>
    </div>
  );
};

export default CustomChipInput;
